import React, { useRef } from 'react';
import PageErrorBoundary from './PageErrorBoundary';

// Keep-alive для вкладок: держит элементы страниц смонтированными в фоне.
// Каждый pathname получает стабильный key → своё независимое поддерево React,
// поэтому состояние (useState/DOM) скрытых вкладок переживает переключения.
// Скрытые записи хранят прежнюю ссылку на элемент — React их не перерендеривает.
const TabsKeepAlive = ({ children, activePath, alivePaths, tabPaths }) => {
  const cacheRef = useRef(new Map()); // path -> элемент страницы

  // Мутации в фазе рендера идемпотентны: set того же ключа и повторное prune
  // дают тот же результат при повторном рендере.
  cacheRef.current.set(activePath, children);
  for (const p of [...cacheRef.current.keys()]) {
    if (p !== activePath && (!tabPaths.includes(p) || !alivePaths.includes(p))) {
      cacheRef.current.delete(p); // вкладка закрыта или вытеснена по LRU
    }
  }

  return [...cacheRef.current.entries()].map(([p, el]) => (
    <div key={p} style={{ display: p === activePath ? 'block' : 'none' }}>
      <PageErrorBoundary path={p}>{el}</PageErrorBoundary>
    </div>
  ));
};

export default TabsKeepAlive;
